module.exports = __webpack_public_path__ + "media/images/logos/gympl-342571b25f8db89f8edb92fac941c7e1.png";